import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M11.921 12.832a4.919 4.919 0 004.921-4.916A4.919 4.919 0 0011.922 3 4.919 4.919 0 007 7.916a4.919 4.919 0 004.921 4.916zM12 14c-2.386.002-4.674.703-6.36 1.95-1.688 1.247-2.637 2.937-2.64 4.7V21h18v-.35c-.003-1.763-.952-3.453-2.64-4.7-1.686-1.247-3.974-1.948-6.36-1.95z" fill="#1E3264" /></svg>;